import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps'
import { bool, func, node, object } from 'prop-types'

const PhotoMarker = ({ position, pin, isOpen, onClick, onClose, children }) => {
  const [markerRef, marker] = useAdvancedMarkerRef()

  return (
    <>
      <AdvancedMarker ref={markerRef} position={position} onClick={onClick}>
        {pin}
      </AdvancedMarker>
      {isOpen && (
        <InfoWindow anchor={marker} onClose={onClose}>
          {children}
        </InfoWindow>
      )}
    </>
  )
}

PhotoMarker.propTypes = {
  position: object,
  pin: node,
  isOpen: bool,
  onClick: func,
  onClose: func,
  children: node
}

export default PhotoMarker
